import { useCallback, useMemo } from 'react';
import { useApi, configApiRef } from '@backstage/core-plugin-api';

const useSonarQubeProjectLinks = (projectKey: string) => {
  const config = useApi(configApiRef);
  const sonarConfig = config.getConfig('bidone.sonarqube');
  const baseUrl = sonarConfig.getString('baseUrl');

  const projectIssueUrl = useMemo(() => {
    return `${baseUrl}/project/issues?id=${projectKey}`;
  }, [projectKey, baseUrl]);

  const getProjectMetricsUrl = useCallback(
    (metric: string) => {
      return `${baseUrl}/component_measures?view=list&metric=${metric}&id=${projectKey}`;
    },
    [projectKey, baseUrl],
  );

  return { projectIssueUrl, getProjectMetricsUrl };
};

export { useSonarQubeProjectLinks };
